let allPeople = [
	{
		"`": "8/2/2022 23:29:03",
		"Email Address": "20107@iiitu.ac.in",
		Name: "Rishabh Kumar",
		"Roll No.": 20107,
		"Personal Email": "akshatmittal2506@gmail.com",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech-Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Skilled in React, Node.js, Flask, and Python, experienced in full-stack development and API creation for scalable solutions.",
		"Instagram username": "Nil",
		"LinkedIn Username": "https://www.linkedin.com/in/rishabh-kumar-438799293/",
		"Twitter Username": "https://twitter.com/0xR111",
		"Phone No.": 8789944397,
		"Profile Photo (preferably focused on face)":
			"Rishabh.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "21235@iiitu.ac.in",
		Name: "Ananya V",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Media Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am flexible and easy going and want to grab on the best opportunities that come in my way.",
		"Instagram username": "nil",
		"LinkedIn Username":
			"nil",
		"Twitter Username":
			"nil",
		"Phone No.": 90,
		"Profile Photo (preferably focused on face)":
			"Ana.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Aparna A",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am a part of design team in software development club. I do design posters , logos ,postcards and I use Adobe illustrator, canva and figma.",
		"Instagram username": "nil",
		"LinkedIn Username":
			"nil",
		"Twitter Username":
			"nil",
		"Phone No.": 9148555573,
		"Profile Photo (preferably focused on face)":
			"Aparna.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Aishwarya Singh",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Proficient in Java development ,Graphic designer and a Tech Enthusiast",
		"Instagram username": "ashhhh411",
		"LinkedIn Username":
			"https://www.linkedin.com/in/aishwarya-singh-51551a255",
		"Twitter Username":
			"nil",
		"Phone No.": 9686115909,
		"Profile Photo (preferably focused on face)":
			"Singh.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Purushotham B M",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am frontend developer,skilled in Reactjs, Javascript, tailwindCss, html ",
		"Instagram username": "https://www.instagram.com/the_purush?igsh=YXJ1YmllZGhhc3o4",
		"LinkedIn Username":
			"https://www.linkedin.com/in/purushotham-bm-63543822a",
		"Twitter Username":
			"https://x.com/Purushotham_007?s=09",
		"Phone No.": 7204144705,
		"Profile Photo (preferably focused on face)":
			"purush.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "MegahaShree V",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Software developer ,Good at designing with figma",
		"Instagram username": "https://www.instagram.com/meghaaa.v?utm_source=qr&igsh=NmQyc2IxZnVseXEz",
		"LinkedIn Username":
			"https://www.linkedin.com/in/meghashree-v-6b4256258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username":
			"nil",
		"Phone No.": 6364754673,
		"Profile Photo (preferably focused on face)":
			"Megashree.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Divya Varshini",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Memeber",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Basics of flutter app development Java,c,c++ basics ",
		"Instagram username": "Itz_dv_2k3 ",
		"LinkedIn Username":
			"https://www.linkedin.com/in/d%F0%9D%92%8A%F0%9D%92%97%F0%9D%92%9A%F0%9D%92%82%F0%9D%92%82-%F0%9D%91%BD%F0%9D%92%82%F0%9D%92%93%F0%9D%92%94%F0%9D%92%89%F0%9D%92%8A%F0%9D%92%8F%F0%9D%92%8A-ab8606252?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username":
			"nil",
		"Phone No.": 7483466469,
		"Profile Photo (preferably focused on face)":
			"Divya.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Anindhaya Sinha",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Programming ",
		"Instagram username": "anindhaya_____",
		"LinkedIn Username":
			"Anindhaya Sinha",
		"Twitter Username":
			"Anindhaya_____",
		"Phone No.": 7058961830,
		"Profile Photo (preferably focused on face)":
			"Sinha.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Shravan",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am a 3rd sem data science student Mostly interested in design and graphics ",
		"Instagram username": "Sravankumar1102",
		"LinkedIn Username":
			"nil",
		"Twitter Username":
			"nil",
		"Phone No.": 7204700369 ,
		"Profile Photo (preferably focused on face)":
			"sravan.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Vatsala Budur",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Enthusiastic about Machine Learning and Deep Learning technologies, constantly exploring and experimenting with new concepts and techniques. ",
		"Instagram username": "nil",
		"LinkedIn Username":
			"https://www.linkedin.com/in/vatsala-budur-83ab25259/",
		"Twitter Username":
			"nil",
		"Phone No.": 9611266007,
		"Profile Photo (preferably focused on face)":
			"Vatsala.jpg",
	},
	{
		"`": "8/2/2022 23:33:39",
		"Email Address": "22235@iiitu.ac.in",
		Name: "Rohith Lokesh",
		"Roll No.": 21235,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Html,Css,Java,Javascript,Python Poster and Brochure Designing Using Canva,FigmaBasic idea on Excel,SQL,Tableau,Data Visualisation",
		"Instagram username": "@rohith.lokesh.2912",
		"LinkedIn Username":
			"https://www.linkedin.com/in/rohith-lokesh-27581824b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username":
			"@rohithl2912",
		"Phone No.": 9632911306,
		"Profile Photo (preferably focused on face)":
			"Rohith.jpg",
	},
  //Content Team

  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Adithi Shibu",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Proficient in python development, content writer and tech enthusiast ",
	"Instagram username": "nil",
	"LinkedIn Username":
		"https://www.linkedin.com/in/adithi-shibu-0a49a3265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"nil",
	"Phone No.": 6364562782,
	"Profile Photo (preferably focused on face)":
		"aditi.jpg",
},
  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Sanjana",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"I am an avid learner, always on the hunt for new experiences",
	"Instagram username": "https://www.instagram.com/sanjana_balasubramanya?igsh=bHV1dmhvb3dqamNu",
	"LinkedIn Username":
		"https://www.linkedin.com/in/sanjana-balasubramanya-b72b25268?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"nil",
	"Phone No.": 7892742807,
	"Profile Photo (preferably focused on face)":
		"sanja.jpg",
},
  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Chandana R",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Basics of C,C++,Java, python ",
	"Instagram username": "https://www.instagram.com/_chandanagowda_23?igsh=dHBrODYxZmlnMjQ3",
	"LinkedIn Username":
		"https://www.linkedin.com/in/chandana-r-gowda-68586725b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"https://x.com/Chandanagowda05?t=QktMlRU9rKz4SLw2ZNUMfg&s=08",
	"Phone No.": 8904739464,
	"Profile Photo (preferably focused on face)":
		"Chandana.jpg",
},
  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Thejaswini M",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		" Graphic design and web development enthusiast",
	"Instagram username": "__tejzzz29_",
	"LinkedIn Username":
		"http://www.linkedin.com/in/thejaswini-m",
	"Twitter Username":
		"nil",
	"Phone No.": 9901212286,
	"Profile Photo (preferably focused on face)":
		"Thejasw.jpg",
},
  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Prem",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Hooked onto cloud hosting, still figuring out why.",
	"Instagram username": "premreddy._",
	"LinkedIn Username":
		"https://www.linkedin.com/in/prem-reddy-59a608245",
	"Twitter Username":
		"notkneesocks ",
	"Phone No.": 9642985537,
	"Profile Photo (preferably focused on face)":
		"Prem.jpg",
},
  {
	"`": "8/2/2022 23:33:39",
	"Email Address": "23235@iiitu.ac.in",
	Name: "Shreenath S",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Content Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Aspiring data scientist and a content writer . Highly Passionate about learning new things , and be a better version of myself.",
	"Instagram username": "shreenath_hebbar",
	"LinkedIn Username":
		"https://www.linkedin.com/in/shreenath-s-hebbar-370376223",
	"Twitter Username":
		"nil",
	"Phone No.": 6362835068,
	"Profile Photo (preferably focused on face)":
		"Shreenath.jpg",
},

//social media team
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Adrija Das Gupta",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Aspiring Full Stack Developer |  HTML | CSS |  JavaScript | Python | Java |  C/C++ | Seeking opportunities to innovate and create impactful web solutions",
	"Instagram username": "_._adrijaaa_._",
	"LinkedIn Username":
		"https://www.linkedin.com/in/Adrija Das Gupta ",
	"Twitter Username":
		"nil",
	"Phone No.": 7899307983,
	"Profile Photo (preferably focused on face)":
		"Das.jpeg",
},
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "K Divit",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Java,CSS,HTML,Python,C++",
	"Instagram username": "https://www.instagram.com/i_am_divith?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr",
	"LinkedIn Username":
		"https://www.linkedin.com/in/divith-kurupati-45093b231?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
	"Twitter Username":
		"https://x.com/DivithKurupati?t=AyigH-ztZKz48oI00qQiWA&s=09",
	"Phone No.": 9611552392,
	"Profile Photo (preferably focused on face)":
		"divit.jpg",
},
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Yuvraj V",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Programming languages I know are C and C+ , basics of html and python  ",
	"Instagram username": "https://www.instagram.com/yuvrajv__?igsh=MWp4NjhsYXdsemo0&utm_source=qr",
	"LinkedIn Username":
		"https://www.linkedin.com/in/yuvraj-v-2401b9292",
	"Twitter Username":
		"nil",
	"Phone No.": 8971728640,
	"Profile Photo (preferably focused on face)":
		"yuvi.jpg",
},
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Vishwas Kumar",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		" Proficient in HTML, CSS, Tailwind CSS, and JavaScript. Skilled in front-end development and responsive web design.",
	"Instagram username": "https://www.instagram.com/vishwas_kumar_2003/",
	"LinkedIn Username":
		"https://www.linkedin.com/in/kunal-sinha-61236a259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"https://x.com/devVishwas2003?t=tGg3G2Iah2t8N3JO752y_g&s=09",
	"Phone No.": 8009885083,
	"Profile Photo (preferably focused on face)":
		"visvas.jpg",
},
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Jaishna S",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Decent with c,c++,Java & python",
	"Instagram username": "https://www.instagram.com/.jaish_04.?igsh=d3diYjZyMDNwYW96",
	"LinkedIn Username":
		"https://www.linkedin.com/in/jaishna-s-01b51828b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"nil",
	"Phone No.":8500524442,
	"Profile Photo (preferably focused on face)":
		"Jaish.jpg",
},

{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Pradipta Kumar",
	"Roll No.": 21235,
	"Personal Email": "rishav7781@gmail.com",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Social Media Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"A web developer and springboot newbie. Learning everything.",
	"Instagram username": "pradiptakumar2002",
	"LinkedIn Username":
		"Pradipta Kumar jena ",
	"Twitter Username":
		"nil",
	"Phone No.": 9937260879,
	"Profile Photo (preferably focused on face)":
		"pradip.jpeg",
},
{
	"`": "8/2/2022 23:33:39",
	"Email Address": "24235@iiitu.ac.in",
	Name: "Rohith Lokesh",
	"Roll No.": 21235,
	"Personal Email": "nil",
	"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Design Team Member",
	"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
		"Html,Css,Java,Javascript,Python Poster and Brochure Designing Using Canva,FigmaBasic idea on Excel,SQL,Tableau,Data Visualisation",
	"Instagram username": "@rohith.lokesh.2912",
	"LinkedIn Username":
		"https://www.linkedin.com/in/rohith-lokesh-27581824b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
	"Twitter Username":
		"@rohithl2912",
	"Phone No.": 9632911306,
	"Profile Photo (preferably focused on face)":
		"Rohith.jpg",
},

	
	{
		"`": "8/2/2022 23:37:14",
		"Email Address": "20309@iiitu.ac.in",
		Name: "Joel Thomas",
		"Roll No.": 20309,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"A quick learner with a background in web-development",
		"Instagram username": "_jt.10_",
		"LinkedIn Username": "https://www.linkedin.com/in/joel-thomas-58a857218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "Nil",
		"Phone No.":8310819628,
		"Profile Photo (preferably focused on face)":
			"Joel.jpg",
	},
	{
		"`": "8/2/2022 23:37:27",
		"Email Address": "20152@iiitu.ac.in",
		Name: "Ashish Ramesh",
		"Roll No.": 20152,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am an avid learner, always on the hunt for new experiences",
		"Instagram username": "nil",
		"LinkedIn Username": "nil",
		"Twitter Username": "nil",
		"Phone No.": "#",
		"Profile Photo (preferably focused on face)":
			"Ashish.jpg",
	},
	{
		"`": "8/2/2022 23:54:48",
		"Email Address": "20240@iiitu.ac.in",
		Name: "Kunal R",
		"Roll No.": 20240,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Proficient in HTML, CSS, JavaScript, Tailwind, React.js basics, competitive coder, passionate about AI, aspiring full-stack web application developer.",
		"Instagram username": "https://www.instagram.com/29captaink?igsh=MWMyaXU0NnU2a2Jydw==",
		"LinkedIn Username": "https://www.linkedin.com/in/kunal-sinha-61236a259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "https://twitter.com/kunalsinha472",
		"Phone No.": 6206788728,
		"Profile Photo (preferably focused on face)":
			"kunal.jpg",
	},
	{
		"`": "8/2/2022 23:58:55",
		"Email Address": "20146@iiitu.ac.in",
		Name: "Sahil Parashram",
		"Roll No.": 20146,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am very active Towards New Technology, a great Helper and Slightly Tensed.",
		"Instagram username": "Priyanshu_singh_1877",
		"LinkedIn Username": "Priyanshu Kumar Singh",
		"Twitter Username": "this-deepraj",
		"Phone No.": "09304011004",
		"Profile Photo (preferably focused on face)":
			"sahil.jpeg",
	},
	{
		"`": "8/2/2022 23:59:50",
		"Email Address": "20157@iiitu.ac.in",
		Name: "Heerath Bhat",
		"Roll No.": 20157,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I'm a developer with a passion for Android development using Flutter and Kotlin, machine learning with TensorFlow, and crafting dynamic web experiences using React. ",
		"Instagram username": "nil",
		"LinkedIn Username":
			"https://www.linkedin.com/in/heerath-bhat-0a27841b2/",
		"Twitter Username": "https://twitter.com/HeerathBhat",
		"Phone No.": 9797243748,
		"Profile Photo (preferably focused on face)":
			"Heerat.jpg",
	},
	{
		"`": "8/3/2022 0:15:27",
		"Email Address": "19331@iiitu.ac.in",
		Name: "Prashant P Subedar",
		"Roll No.": 19331,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"President",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Web Developer [Good working with React.js and Angular.js Framework]",
		"Instagram username": " prashant_subedar13",
		"LinkedIn Username": "https://www.linkedin.com/in/prashant-p-subedar-34abb71b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
		"Twitter Username": "nil",
		"Phone No.": "8106084090",
		"Profile Photo (preferably focused on face)":
			"Prashant.jpeg",
	},
	{
		"`": "8/3/2022 6:36:51",
		"Email Address": "21334@iiitu.ac.in",
		Name: "Shrish Agarwal",
		"Roll No.": 21334,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Media Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I have an expertise in DBMS, PL/SQL, ORACLE and Cyber Security ",
		"Instagram username": "https://www.instagram.com/agarwal.shrish?igsh=MXdvcjB5b3d5NndoYg==",
		"LinkedIn Username": "https://www.linkedin.com/in/shrish-agarwal-346496270?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "nil",
		"Phone No.": 9113778721,
		"Profile Photo (preferably focused on face)":
			"Shrish.jpg",
	},
	{
		"`": "8/3/2022 18:52:19",
		"Email Address": "21110@iiitu.ac.in",
		Name: "Kashish Pandey",
		"Roll No.": 21110,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Media Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I encompass skills in DBMS, PL/SQL, Oracle, and fundamental cybersecurity principles like encryption and network security.",
		"Instagram username": "https://www.instagram.com/kashishpandey__?igsh=MTMza292azdsYWJhbw%3D%3D&utm_source=qr",
		"LinkedIn Username": "http://linkedin.com/in/kashish-pandey-a042821a7",
		"Twitter Username": "nil",
		"Phone No.": 9471740040,
		"Profile Photo (preferably focused on face)":
			"kashish.jpg",
	},
	{
		"`": "8/3/2022 20:06:52",
		"Email Address": "21239@iiitu.ac.in",
		Name: "Nisaar Ahmad",
		"Roll No.": 21239,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)": "Media Team Member",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Hard working, passionate about learning new things and technology and having good expertise in Tech. always ready to learn new things.",
		"Instagram username": "(nisar__ahamed)https://www.instagram.com/nisar__ahamed?igsh=MW05cjFtZmNoZHd3Zg==",
		"LinkedIn Username": "https://www.linkedin.com/in/nisar-ahamed-aaaaa1214?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "nil",
		"Phone No.":9019164344 ,
		"Profile Photo (preferably focused on face)":
			"Nisar.jpg",
	},
	
	{
		"`": "8/5/2022 22:05:09",
		"Email Address": "19307@iiitu.ac.in",
		Name: "Narayanan S",
		"Roll No.": 19307,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Vice President",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Graphic Designer specialized in softwares like Figma and Canva, Python Enthusiast",
		"Instagram username": "https://www.instagram.com/",
		"LinkedIn Username": "https://www.linkedin.com/in/narayanan-sreeraman-39662a1a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "nil",
		"Phone No.": "9986719979 ",
		"Profile Photo (preferably focused on face)":
			"Nara.jpg",
	},
	
	{
		"`": "8/8/2022 20:04:36",
		"Email Address": "19137@iiitu.ac.in",
		Name: "Hakeem Hameem",
		"Roll No.": 19137,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Tech Lead",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Wake up to reality! Nothing ever goes as planned in this world. The longer you live, the more you realize that in this reality, only pain, suffering, and futility exist",
		"Instagram username": "_hameemhussain",
		"LinkedIn Username": "www.linkedin.com/in/hameem1",
		"Twitter Username": "nil",
		"Phone No.": "7006385519",
		"Profile Photo (preferably focused on face)":
			"Hameem.jpeg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@iiitu.ac.in",
		Name: "Ullas",
		"Roll No.": 19155,
		"Personal Email": "pvanshika217@gmail.com",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Media Lead",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"ML & DL buff learning to build various AI models using ANN & CNN handy with a camera",
		"Instagram username": "im_ullas",
		"LinkedIn Username": "Ullas mohan",
		"Twitter Username": "Im_ullas",
		"Phone No.": "9900531583",
		"Profile Photo (preferably focused on face)":
			"Ullas.jpeg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@iiitu.ac.in",
		Name: "Abhinav Majeti",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Design Lead",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I am a tech enthusiast who loves to learn an implement new technologies, solve problems and build solutions that contribute to a better future.",
		"Instagram username": "nil",
		"LinkedIn Username": "nil",
		"Twitter Username": "nil",
		"Phone No.": "+#",
		"Profile Photo (preferably focused on face)":
			"Maja.jpeg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@iiitu.ac.in",
		Name: "Rounak Pande",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Social Media Lead",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Social Media Influencer!",
		"Instagram username": "rounnakk.p",
		"LinkedIn Username": "https://www.linkedin.com/in/rounak-pande-3a3739223?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "rounakpande1",
		"Phone No.": "9067794457",
		"Profile Photo (preferably focused on face)":
			"pande.jpeg",
	},






	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@iiitu.ac.in",
		Name: "Kathrine John Kennedy",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Content Lead",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Enthusiastic about Cryptography Machine Learning. Database management is where I find solace. Been to Airbus, NetApp, Caterpillar, SAP as a public speaker. A holistic learner, takes up new challenges.",
		"Instagram username": "nil",
		"LinkedIn Username": "https://www.linkedin.com/in/katharine-kennedy-687981267/",
		"Twitter Username": "nil",
		"Phone No.": "+#",
		"Profile Photo (preferably focused on face)":
			"kk.jpg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@",
		Name: "Koushik Ram",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Event Cordinator ",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Full Stack Developer | Web Design Enthusiast | Tech Innovator | ISE Undergrad @MVJCE",
		"Instagram username": "https://www.instagram.com/jr.ram7",
		"LinkedIn Username": "https://www.linkedin.com/in/itskoushikram/",
		"Twitter Username": "https://x.com/koushik_ram18?t=FaPTrw6yrtZe-7hPConXjQ&s=09",
		"Phone No.": "9886039692",
		"Profile Photo (preferably focused on face)":
			"kushik.jpeg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@",
		Name: "Heerat Bhat",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Moderator",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"I'm a developer with a passion for Android development using Flutter and Kotlin, machine learning with TensorFlow, and crafting dynamic web experiences using React. ",
		"Instagram username": "nil",
		"LinkedIn Username": "https://www.linkedin.com/in/heerath-bhat-0a27841b2/",
		"Twitter Username": "https://twitter.com/HeerathBhat",
		"Phone No.": "9797243748",
		"Profile Photo (preferably focused on face)":
			"Heerat.jpg",
	},
	{
		"`": "8/8/2022 22:50:06",
		"Email Address": "19155@",
		Name: "Greeshma DJ",
		"Roll No.": 19155,
		"Personal Email": "nil",
		"Designation(E.g:- Web Developer, Graphic Designer, CP, etc)":
			"Moderator",
		"A one liner to describe yourself.(E.g:- I am an avid learner, always on the hunt for new experiences)":
			"Experienced programmer proficient in HTML, SQL, C++, Java, and C. Completed 3 internships, contributed to hackathon projects (smart electricity, trolley, ambulance).",
		"Instagram username": "https://instagram.com/greeshma_dj?igshid=YzAwZjE1ZTI0Zg==",
		"LinkedIn Username": "https://www.linkedin.com/in/greeshma-dj-5b6a06242?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
		"Twitter Username": "nil",
		"Phone No.": "7483494661",
		"Profile Photo (preferably focused on face)":
			"Greeshma.jpeg",
	},
	
];

export default allPeople;
